<template>
  <div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')"
      class="aviso-amarelo"
    >
      Ação de preenchimento desses dados está com a pessoa (cliente). <a
        style="color:blue"
        @click="abrirAlterarStatus()"
      >Clique aqui</a>, para você continuar o preenchimento.
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Em análise')"
      class="aviso-amarelo"
    >
      A ação da proposta está com você, confira os dados e envie o contrato para assinar.
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Aguardando assinatura')"
      class="aviso-amarelo"
    >
      O contrato está em tramitação de assinatura, quando todos assinarem a proposta será finalizada.
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Contrato assinado')"
      class="aviso-amarelo"
    >
      Contrato assinado! Para fazer o download do contrato clique no botão de imprimir disponível na barra lateral da proposta.
    </div>

    <validation-observer ref="validacao">
      <transferencia-matriz-filial
        v-if="valueInner.tipoProposta === 'transferencia'"
        ref="transferencia"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        :desabilitar-campos="preGeracao.enviadoParaAnalise"
        :proposta-contrato="valueInner.contrato"
        :proposta-valor="valueInner.valorTotalPropostaAuditar"
        :proposta-template="valueInner.templateContrato"
        :proposta-id="valueInner.id"
        :pendente-analise="isPendenteAnalise"
        :habilitar-campo="isHabilitado"
        :dados-socio="!valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Aguardando envio de dados')"
        @contrato-alterado="contratoAlterado($event)"
        @editar-socio="socioEmAlteracao"
      />

      <constituicao-matriz
        v-else-if="valueInner.tipoProposta === 'constituicao'"
        ref="constituicao"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        :proposta-contrato="valueInner.contrato"
        :proposta-valor="valueInner.valorTotalPropostaAuditar"
        :proposta-template="valueInner.templateContrato"
        :proposta-id="valueInner.id"
        :habilitar-campo="isHabilitado"
        :pendente-analise="isPendenteAnalise"
        :dados-socio="!valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Aguardando envio de dados')"
        @contrato-alterado="contratoAlterado($event)"
        @editar-socio="socioEmAlteracao"
      />

      <div class="my-3 border p-3 rounded">
        <!-- show current order read-only; editing happens in modal -->
      </div>

    </validation-observer>
    <b-row class="mt-2">
      <b-col>
        <div style="display: flex;justify-content: flex-end;">
          <b-btn
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="desabilitarBotao"
            @click="salvarPreGeracao"
          >
            Salvar
          </b-btn>
          <b-btn
            variant="danger"
            size="sm"
            @click="cancelar"
          >
            Cancelar
          </b-btn>
        </div>
      </b-col>
    </b-row>
    <loading
      :is-loading="isLoading"
      :cancelar-upload="cancelarBusca"
    />
    <alterar-status
      ref="alterarStatus"
      :proposta-atual="valueInner"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import { generateCode } from '@core/utils/utils'
import { ValidationObserver } from 'vee-validate'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'

export default {
  name: 'PreGeracaoContratoPropostaTab',
  components: {
    ValidationObserver,
    TransferenciaMatrizFilial: () => import('./components/shared/transferencia-matriz-e-filial-proposta/TransferenciaMatrizEFilialProposta.vue'),
    ConstituicaoMatriz: () => import('./components/shared/constituicao-matriz/ConstituicaoMatriz.vue'),
    AlterarStatus: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/alterar-status/AlterarStatus.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
  },
  props: {
    propostaAtual: {
      type: Object,
      default: () => {},
    },
    statusProposta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      preGeracao: {
        eTipoFaturamentoBoletos: null,
        contratoSubstituir: null,
        emailsBoletosNFs: [],
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          veioDoRFB: false,
          atualizarDados: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
      },
      valueInner: {},
      socioEmEdicao: false,
    }
  },
  computed: {
    ...mapGetters('proposta', ['rateioRow', 'existeMaisDeUmContratante', 'getStatusProposta']),
    isHabilitado() {
      return this.valueInner.selecaoPreenchimento === 'auditar' && this.valueInner.statusProposta !== 'aguardandoassinatura' && this.valueInner.statusProposta !== 'finalizada'
    },
    desabilitarBotao() {
      return this.valueInner.etiquetas.some(som => som.descricao === 'Contrato assinado' && som.etiquetaSistema === true)
    },
    desabilitarBotaoAssinatura() {
      return this.getStatusProposta === 8 || this.valueInner.etiquetas.some(som => som.descricao === 'Aguardando envio de dados' && som.etiquetaSistema === true)
    },
    isPendenteAnalise() {
      return this.valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Em análise')
    },
  },
  watch: {
    propostaAtual: {
      handler(value) {
        this.valueInner = { ...(value || {}) }
      },
      deep: true,
    },
  },
  created() {
    this.valueInner = { ...this.propostaAtual }
    this.showPreGeracao()
  },
  methods: {
    ...mapActions('proposta', ['limparRateio']),
    contratoAlterado(value) {
      this.$set(this.valueInner, 'contrato', value)
    },
    showPreGeracao() {
      if (this.valueInner.id > 0) {
        api.getPreGeracaoContrato(this.valueInner.id)
          .then(result => {
            this.preGeracao = result.data ? result.data : this.preGeracao
            this.preGeracao.contratoSubstituir = this.valueInner.contrato
            this.preGeracao.carregado = true

            if (this.valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')) {
              this.preGeracao.enviadoParaAnalise = true
            }
            const itemChecklist = this.valueInner.itemChecklistPropostas.find(find => find.tipoRegra === 'tags')
            if (itemChecklist && itemChecklist.listaRespostas && !result.data) {
              this.getEmpresas(itemChecklist)
            }
            if (this.valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')) {
              this.preGeracao.enviadoParaAnalise = true
            }
            this.$emit('socios-carregados', this.preGeracao.socios)

            this.preGeracao.eTipoFaturamentoBoletos = (!result.data || result.data.eTipoFaturamentoBoletos === 0) ? null : result.data.eTipoFaturamentoBoletos
          }).finally(() => {
            this.isLoading = false
          })
      }
    },
    getEmpresas(itemChecklist) {
      this.isLoading = true
      apiPreGeracao.getEmpresasPreGeracao(itemChecklist.listaRespostas, 0, axios.CancelToken)
        .then(payload => {
          this.isLoading = false
          const dados = payload.data
          this.preGeracao.empresas = dados.empresas
          if (!this.valueInner.filial) {
            this.preGeracao.socios = dados.socios
          }
          if (!this.preGeracao.socios || this.preGeracao.socios.length === 0) {
            this.adicionarSocio()
          }
          this.preGeracao.carregado = true
          this.preGeracao.realizadoBusca = true
          this.$emit('socios-carregados', this.preGeracao.socios)
        }).catch(err => {
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    cancelar() {
      this.$emit('fechar-modal')
    },
    adicionarSocio() {
      this.preGeracao.socios = [{
        nome: null,
        cpf: null,
        veioDoRFB: false,
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        atualizarDados: false,
        code: generateCode(),
      }]
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const ref = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia : this.$refs.constituicao

      const anexosRef = ref && ref.$refs ? ref.$refs.anexos : null
      const arquivo = anexosRef && anexosRef.getArquivosAnexados ? anexosRef.getArquivosAnexados() : null

      const fileCertificado = arquivo ? arquivo.certificado : null
      const fileContratual = arquivo ? arquivo.contratual : null
      const fileOutros = arquivo ? arquivo.outros : null

      if (fileCertificado) {
        const name = `certificado;${fileCertificado.name || fileCertificado.filename}`
        formData.append('files', fileCertificado.file, name)
      }
      if (fileContratual) {
        const name = `contratual;${fileContratual.name || fileContratual.filename}`
        formData.append('files', fileContratual.file, name)
      }
      if (fileOutros) {
        const name = `outros;${fileOutros.name || fileOutros.filename}`
        formData.append('files', fileOutros.file, name)
      }

      let arquivosSocio = []
      try {
        arquivosSocio = ref && ref.retornaTodosArquivos ? ref.retornaTodosArquivos() : []
      } catch (e) {
        arquivosSocio = []
      }

      for (let index = 0; index < arquivosSocio.length; index += 1) {
        const { file, nome } = arquivosSocio[index]
        if (file && nome) {
          formData.append('files', file, nome)
        }
      }

      formData.append('body', JSON.stringify(body))

      return formData
    },
    hasEmailDuplicado(array) {
      const valuesSoFar = Object.create(null)
      const arr = array.filter(fil => fil.email && fil.email !== '')
      for (let i = 0; i < arr.length; i += 1) {
        const value = arr[i].email
        if (value in valuesSoFar) {
          return true
        }
        valuesSoFar[value] = true
      }
      return false
    },
    regrasSalvarPreGeracao(dados) {
      if (!dados.socios || dados.socios.some(socios => socios.nome === '' || !socios.nome)) {
        this.$erro('É obrigatório informar o nome dos sócios')
        return false
      } if (!dados.socios || dados.socios.some(socios => socios.inscricao === '' || !socios.inscricao)) {
        this.$erro('É obrigatório informar a inscrição federal dos sócios')
        return false
      } if (dados.anexosECertificado && dados.anexosECertificado.senhaIncorreta) {
        this.$erro('Informe a senha correta do certificado')
        return false
      } if (dados.anexosECertificado && dados.anexosECertificado.anexoVencido) {
        this.$erro('Não é permitido anexar certificado vencido!')
        return false
      } if (this.hasEmailDuplicado(dados.socios)) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
        return false
      }
      return true
    },
    salvarPreGeracao() {
      const atualizarDadosContemNulll = this.preGeracao.socios.some(socio => socio.atualizarDados === null && socio.socioJaExisteNoHub && !socio.veioDoHub)
      const emailDuplicado = this.hasEmailDuplicado(this.preGeracao.socios)
      if (!atualizarDadosContemNulll && !emailDuplicado) {
        const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
        const value = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
        if (this.regrasSalvarPreGeracao(dados)) {
          const formData = this.getFormDataBody(value)
          apiPreGeracao.updatePreGeracaoContrato(this.valueInner.id, formData)
            .then(() => {
              api.substituirTagsContrato(this.preGeracao, this.valueInner.id, true)
                .then(payload => {
                  this.valueInner.contrato = payload.data
                  if (!this.valueInner.contrato || this.valueInner.contrato === '') {
                    this.$erro('O texto do contrato não deve ser vazio!')
                  }
                })
                .catch(err => {
                  this.isLoading = false
                  const resolved = this.$resolveError(err)
                  this.$erro(resolved.detail || resolved.title || 'Ocorreu um erro ao enviar os dados para análise.')
                  throw err
                })
              this.$sucesso('Dados salvos')
            })
            .catch(err => {
              const resolved = this.$resolveError(err)
              this.$erro(resolved.detail || resolved.title || err.message)
              throw err
            })
        }
      } else if (atualizarDadosContemNulll) {
        this.$erro('Existe sócio já cadastrado no sistema e não foi informado o que o sistema deve fazer com os dados gerais no cadastro automático desse sócio! Verifique a informação.')
      } else if (emailDuplicado) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
      }
    },
    limparCampos() {
      this.limparRateio()
      this.preGeracao = {
        contratoSubstituir: '',
        emailsBoletosNFs: [],
        realizadoBusca: true,
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
      }
    },
    abrirAlterarStatus() {
      this.$emit('abrir-modal-status')
    },
    cancelarBusca() {
      this.isLoading = false
      api.cancelarBusca()
    },
    validacaoManual(dados) {
      if (!dados.socios || dados.socios.length === 0 || (dados.socios.length === 1 && dados.socios.some(som => !som.nome || som.nome === ''))) {
        this.$erro('Deve ter no mínimo um sócio adicionado!')
        return false
      }
      if (!dados.socios.some(some => some.responsavelRFB)) {
        this.$erro('Informe qual sócio é responsável perante a RFB para enviar os dados para análise!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && (!dados.anexosECertificado.tipoCertificado || dados.anexosECertificado.tipoCertificado === '0')) {
        this.$erro('Selecione um tipo de certificado!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.nomeArquivoCertificado || dados.anexosECertificado.nomeArquivoCertificado === '')) {
        this.$erro('Certificado é obrigatório!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.senhaCertificado || dados.anexosECertificado.senhaCertificado === '')) {
        this.$erro('Preencha a senha')
        return false
      }
      if (dados.socios.some(som => !som.email || som.email === '')) {
        this.$erro('Insira um email valido')
        return false
      }
      if ((this.valueInner.tipoProposta === 'transferencia' || (this.valueInner.tipoProposta === 'constituicao' && this.valueInner.filial))
          && (!dados.anexosECertificado.nomeArquivoContratual || dados.anexosECertificado.nomeArquivoContratual === '')) {
        this.$erro('Arquivo contratual é obrigatório!')
        return false
      }
      if (dados.anexosECertificado.anexoVencido) {
        this.$erro('Não é permitido anexar certificado vencido!')
        return false
      }
      if (this.hasEmailDuplicado(dados.socios)) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
        return false
      }
      const linhasValidacao = this.rateioRow.filter(filter => filter.subTotal !== 0 && filter.subTotal !== null)
      if (this.existeMaisDeUmContratante && this.valueInner.tipoProposta === 'transferencia' && (this.valueInner.filial || (dados.eTipoFaturamentoBoletos === 1)) && (linhasValidacao.length === 0 || linhasValidacao.some(som => som.children.some(some => !some.subTotal || some.subTotal === 0)))) {
        this.$erro('É obrigatório realizar o rateio de valores para Omie! Verifique a informação.')
        return false
      }
      return true
    },
    socioEmAlteracao() {
      this.socioEmEdicao = true
    },
  },
}
</script>
